import Theme from '../../constants/Theme';
import styled from 'styled-components';
import theme from 'styled-theming';
import { NavLink } from 'react-router-dom';
import { widthMixin } from '../mixins';

const LegalGrid = styled.div`
  display: grid;
  grid-auto-rows: auto;
`;

const LegalHeadBg = styled.div`
  background: ${theme('mode', Theme.legal.head)};
`;

const LegalContent = styled.div`
  padding: 20px;
  justify-self: center;
  background: ${Theme.legal.bg};
  ${widthMixin};
`;

const LegalBanner = styled.div`
  display: grid;
  align-content: center;
  justify-content: center;
  height: 200px;
  color: ${Theme.legal.banner};
  font-size: 26px;
  font-weight: bold;
`;

const LegalLinks = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-content: center;
  justify-content: center;
  border-bottom: 1px solid #ddd;
`;

const LegalNavLink = styled(NavLink)`
  text-decoration: none;
  padding: 20px;
  color: #666;
  &.active {
    font-weight: bold;
    color: #000;
  }
`;

export { LegalHeadBg, LegalContent, LegalGrid, LegalBanner, LegalLinks, LegalNavLink };



// WEBPACK FOOTER //
// ./src/components/UI/LegalUI.tsx